import { AudioVideoConferenceComponent } from "./audio-video-conference.component";
import { InviteUserToMeetingModule } from "./inviteUserToMeeting/invite-user-to-meeting.module";

export const AudioVideoConferenceModule = angular
    .module('audioVideoConference',[InviteUserToMeetingModule])
    .component(AudioVideoConferenceComponent.selector, AudioVideoConferenceComponent.component)
    .name;